import { move } from '@dmp/shared/helpers';
import type { StoreState } from '../../state-types';
import { makeSurveyDirty } from '../utils/make-survey-dirty';

/** Move a card into a new index */
export const moveCard =
    (cardId: string, newIndex: number) =>
    (state: StoreState): StoreState => {
        const cardIds = state.survey.cardIds;
        const oldIndex = cardIds.indexOf(cardId);

        // invalid when index < 0 or > array length
        const invalid =
            oldIndex < 0 ||
            newIndex < 0 ||
            oldIndex > cardIds.length ||
            newIndex > cardIds.length;

        if (invalid) {
            throw new Error('Card index is invalid');
        }

        const newCardIds = move(cardIds, oldIndex, newIndex);

        return makeSurveyDirty({
            ...state,
            survey: {
                ...state.survey,
                cardIds: newCardIds,
            },
        });
    };
